import { render, staticRenderFns } from "./Edicao.vue?vue&type=template&id=147e6b4c"
import script from "./Edicao.vue?vue&type=script&lang=js"
export * from "./Edicao.vue?vue&type=script&lang=js"
import style0 from "./Edicao.vue?vue&type=style&index=0&id=147e6b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports